module.exports = __webpack_public_path__ + "static/media/ico-website.11fd6fc6.svg";